<template>
  <div>
    <div class="block__wrapper" id="contact">
      <div class="block__content">
        <h1 class="alignCenter" id="faq">Usein kysytyt kysymykset:</h1>
        <div class="card__wrapper">
          <div v-for="(faq, index) in faqs" :key="index" class="question">
            <h3>{{ faq.title }}</h3>
            <p>{{ faq.answer }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      faqs: [
        {
          title: "Millaisissa tapahtumissa soitatte?",
          answer:
            "Melkein missä tahansa: tyypilliset esiintymisemme ovat häissä, yritysten pikkujouluissa tai syntymäpäivillä. Emme ole ronkeleita."
        },
        {
          title: "Mitä saan rahoillani?",
          answer:
            "Huikeat bileet! Lähtökohtaisesti soitamme keikoillamme kolme 45min settiä. Tuomme mukanamme kaiken tarvittavan: soittimet, äänentoistolaitteiston, ääniteknikon ja valot. Pyydä tarjous yhteydenottolomakkeen kautta."
        },
        {
          title: "Saanko toivoa biisejä?",
          answer:
            "Tottakai! Rakennamme keikkamme rungon itse tilaajan antamien suuntaviivojen pohjalta, mutta myös täsmätoivebiisit ovat aina tervetulleita."
        },
        {
          title: "Onko esiintymisellenne maantieteellisiä rajoitteita?",
          answer:
            "Ei: meidät voi tilata esiintymään mihin tahansa Suomessa. Lisäämme vain matkakustannuksemme esiintymispalkkiomme päälle."
        },
        {
          title: "Miten maksu hoituu?",
          answer:
            "Toimitamme tilaajalle laskun esiintymispalkkiostamme keikan jälkeen."
        },
        {
          title: "Mitä soittimia teillä on bändissänne?",
          answer:
            "Vakiokokoonpanossamme meillä on laulun ja taustalaulujen lisäksi akustinen kitara, sähkökitara, basso, koskettimet ja rummut."
        }
      ]
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1:first-child {
  margin: 0;
}

.block__wrapper {
  width: 100%;
  min-height: 100vh;
  background-color: var(--lighter-background);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 0 4rem 0;
}

.block__content {
  padding-top: 4rem;
  width: 75%;
}

.card__wrapper {
  width: 75%;
  margin: auto;
  margin-top: 2rem;
  padding: 2rem;
}
.question {
  margin-bottom: 4rem;
}

@media (max-width: 900px) {
  .block__content {
    width: 100%;
    padding: 2rem;
  }
  .card__wrapper {
    width: 100%;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Faq.vue